<template>
    <div>
        <div class="input-group">
            <input
                v-model="alt"
                class="form-control"
                type="text"
                placeholder="атрибут alt для изображения"
                @focus.prevent=""
            >
        </div>
        <div class="dg-clear" />
        <hr>
        <button
            class="dg-btn dg-btn--cancel"
            @click.prevent="handleDismiss()"
        >
            <span>Отмена</span>
        </button>
        <button
            class="dg-btn dg-btn--ok dg-pull-right"
            @click.prevent="handleProceed()"
        >
            <span class="dg-btn-content">
                <span>Вставить</span>
            </span>
        </button>
        <div class="dg-clear" />
    </div>
</template>

<script>
    import DialogMixin from 'vuejs-dialog/dist/vuejs-dialog-mixin.min.js';

    export default {
        mixins: [DialogMixin],
        data: function() {
            return {
                alt: this.options.alt,
            }
        },
        methods: {
            handleProceed: function() {
                this.proceed(this.alt)
            },
            handleDismiss() {
                this.proceed(null);
            }
        }
    }
</script>
